export default {
    isLoggedIn: state => !!state.token,
}